import { Injectable } from "@angular/core";

@Injectable()
export class TabbingOrderService {
    /**
     * Map for tabbing order
     * {
     * entity - id of the entity
     * children? - child entities
     * onClose? - function to be called on close
     * launchPoint? - point from which entity is launched
     * parent? - parent entity specially used for timer as we are using timer1 and timer2 
     *           to set the tab order of timer and timer1CrossBtn do not have any parent 
     *           so to handle onclose functionality of timer1CrossBtn, we are using parent
     * }
     */
    tabOrderMap = { 
        largeDesktop: [
            {entity: 'notesPin'},
            {entity: 'hotspots'},
            {entity: 'timer1CrossBtn',
                parent: 'timerBtn',
                children: [
                    {entity: 'timer1'}
                ],
                onClose: this.focusParent.bind(this)
            }, 
            {entity: 'homeBtn'},
            {entity: 'tocBtn',
                children: [
                    {entity: 'tocCrossBtn',
                    children: [
                        {entity: 'tocContent'
                    }],
                    onClose: this.focusParent
                    }],
            },
            {entity: 'toolsBtn',
                children:[
                    {entity: 'penBtn',
                        children: [
                            {entity: 'drawingToolsBtn'},
                            {entity: 'drawingColorBtn',
                                children: [
                                    {entity: 'drawingColor',
                                        onClose: this.focusParent
                                       }
                                ]
                            },
                            {entity: 'drawingStrokeBtn',
                                children: [
                                    {entity: 'drawingStroke',
                                        onClose: this.focusParent
                                    }
                                ]
                            },
                            {entity: 'highlighterBtn'},
                            {entity: 'highlighterColorBtn',
                                children: [
                                    {entity: 'highlighterColor',
                                        onClose: this.focusParent
                                       }
                                ]
                            },
                            {entity: 'highlighterStrokeBtn',
                                children: [
                                    {entity: 'highlighterStroke',
                                     onClose: this.focusParent
                                    }
                                ]
                            },
                            {entity: 'eraserBtn'},
                            {entity: 'undoBtn'},
                            {entity: 'redoBtn'},
                        ]
                    },
                    {entity: 'notesBtn',
                        children: [
                            {entity: 'notesClosebtn',
                                children: [
                                    {entity: 'notesContent'}
                                ],
                                onClose: (entity, options?) => {
                                    if(entity.launchPoint){
                                        let launchPointDomRef = document.getElementById(entity.launchPoint).children[0] as HTMLElement;
                                        setTimeout(() => {
                                            launchPointDomRef.focus();
                                        },);
                                        entity.launchPoint = null;
                                    }
                                    else{
                                        this.focusParent(entity,options);
                                    }
                                }
                            },
                        ]
                    },
                    {entity: 'selectionBtn',
                        children: [
                            {entity: 'spotlightBtn',
                                children: [
                                    {entity: 'tipModal1',
                                        onClose: this.focusParent.bind(this)
                                    }
                                ]
                            },
                            {entity: 'maskBtn',children: [
                                {entity: 'tipModal2',
                                    onClose: this.focusParent.bind(this)
                                }
                            ]
                        },
                        ]
                    },
                    {entity: 'timerBtn',
                        children: [
                            {entity: 'timer2CrossBtn',
                                children: [
                                    {entity: 'timer2'}
                                ],
                                onClose: this.focusParent.bind(this)
                            }, 
                        ]
                    },
                ]
            },
            {entity: 'zoomOutBtn'},
            {entity: 'zoomInBtn'},
            {entity: 'fitToWidthBtn'},
            {entity: 'fitToHeightBtn'},
            {entity: 'jumpToPageBtn'},  
            {entity: 'previousPageBtn'},
            {entity: 'navigateToPageBtn',
                children: [
                    {entity: 'numpad'}
                ]
            },
            {entity: 'nextPageBtn'},
            {entity: 'toggleSingleDoublePage'},
            {entity: 'bookDropdownBtn',
                children: [
                    {entity: 'bookDropdownContent'}
                ]
            },
            {entity: 'invertToolbarBtn'},
            {entity: 'saveBtn'},

            ],
        desktop: [
            {entity: 'notesPin'},
            {entity: 'hotspots'}, 
            {entity: 'timer1CrossBtn',
                parent: 'timerBtn',
                children: [
                    {entity: 'timer1'}
                ],
                onClose: this.focusParent.bind(this)
            }, 
            {entity: 'homeBtn'},
            {entity: 'tocBtn',
                children: [
                    {entity: 'tocCrossBtn',
                    children: [
                        {entity: 'tocContent'
                    }],
                    onClose: this.focusParent
                    }],
            },
            {entity: 'toolsBtn',
                children:[
                    {entity: 'penBtn',
                        children: [
                            {entity: 'drawingToolsBtn'},
                            {entity: 'drawingColorBtn',
                                children: [
                                    {entity: 'drawingColor',
                                        onClose: this.focusParent
                                       }
                                ]
                            },
                            {entity: 'drawingStrokeBtn',
                                children: [
                                    {entity: 'drawingStroke',
                                     onClose: this.focusParent
                                    }
                                ]
                            },
                            {entity: 'highlighterBtn'},
                            {entity: 'highlighterColorBtn',
                                children: [
                                    {entity: 'highlighterColor',
                                        onClose: this.focusParent
                                       }
                                ]
                            },
                            {entity: 'highlighterStrokeBtn',
                                children: [
                                    {entity: 'highlighterStroke',
                                     onClose: this.focusParent
                                    }
                                ]
                            },
                            {entity: 'eraserBtn'},
                            {entity: 'undoBtn'},
                            {entity: 'redoBtn'},
                        ]
                    },
                    {entity: 'notesBtn',
                        children: [
                            {entity: 'notesClosebtn',
                                children: [
                                    {entity: 'notesContent'}
                                ],
                                onClose: (entity, options?) => {
                                    if(entity.launchPoint){
                                        let launchPointDomRef = document.getElementById(entity.launchPoint).children[0] as HTMLElement;
                                        setTimeout(() => {
                                            launchPointDomRef.focus();
                                        },);
                                        entity.launchPoint = null;
                                    }
                                    else{
                                        this.focusParent(entity,options);
                                    }
                                }
                            },
                        ]
                    },
                    {entity: 'selectionBtn',
                        children: [
                            {entity: 'spotlightBtn',
                                children: [
                                    {entity: 'tipModal1',
                                        onClose: this.focusParent.bind(this)
                                    }
                                ]
                            },
                            {entity: 'maskBtn',children: [
                                {entity: 'tipModal2',
                                    onClose: this.focusParent.bind(this)
                                }
                            ]
                        },
                        ]
                    },
                    {entity: 'timerBtn',
                        children: [
                            {entity: 'timer2CrossBtn',
                                children: [
                                    {entity: 'timer2'}
                                ],
                                onClose: this.focusParent.bind(this)
                            }, 
                        ]
                    },
                ]
            },
            {entity: 'zoomDropdownBtn',
                children: [
                    {entity: 'zoomMenuBtns'},
                ],
            },
            {entity: 'jumpToPageBtn'},  
            {entity: 'previousPageBtn'},
            {entity: 'navigateToPageBtn',
                children: [
                    {entity: 'numpad'}
                ]
            },
            {entity: 'nextPageBtn'},
            {entity: 'toggleSingleDoublePage'},
            {entity: 'bookDropdownBtn',
                children: [
                    {entity: 'bookDropdownContent'}
                ]
            },
            {entity: 'invertToolbarBtn'},
            {entity: 'saveBtn'},
    
            ],
        mobile: [
            {entity: 'notesPin'},
            {entity: 'hotspots'}, 
            {entity: 'homeBtn'},
            {entity: 'tocBtnMobile',
                children: [
                    {entity: 'tocCrossBtn',
                    children: [
                        {entity: 'tocContent'
                    }],
                    onClose: this.focusParent
                    }],
            },
            {entity: 'penBtn',
                children: [
                    {entity: 'undoBtnPen'},
                    {entity: 'redoBtnPen'},
                    {entity: 'mobilePenColorDropdown',
                        children: [
                            {entity: 'drawingColor',
                                onClose: this.focusParent
                               }
                        ]
                    },
                    {entity: 'drawingStrokeBtn',
                        children: [
                            {entity: 'drawingStroke',
                                onClose: this.focusParent
                            }
                        ]
                    },
                ]},
                {entity: 'highlighterBtn',
                    children: [
                    {entity: 'undoBtnHighlighter'},
                    {entity: 'redoBtnHighlighter'},
                    {entity: 'highlighterColorBtn',
                        children: [
                            {entity: 'highlighterColor',
                                onClose: this.focusParent
                               }
                        ]
                    },
                    {entity: 'highlighterStrokeBtn',
                        children: [
                            {entity: 'highlighterStroke',
                             onClose: this.focusParent
                            }
                        ]
                    },
                ]},
                    {entity: 'eraserBtn'},
                    {entity: 'notesBtnMobile',
                        children: [
                            {entity: 'notesClosebtn',
                                children: [
                                    {entity: 'notesContent'}
                                ],
                                onClose: (entity, options?) => {
                                    if(entity.launchPoint){
                                        let launchPointDomRef = document.getElementById(entity.launchPoint).children[0] as HTMLElement;
                                        setTimeout(() => {
                                            launchPointDomRef.focus();
                                        },);
                                        entity.launchPoint = null;
                                    }
                                    else{
                                            this.focusParent(entity,options);
                                    }
                                }
                            },
                        ]
                    },
            {entity: 'previousPageBtn'},
            {entity: 'nextPageBtn'},
            ]
        }
    flattenedTabOrderMap:any = {};
    currentWindow: string;

    // To handle tab order of timer and its cross button
    // initial value of tab index is set to timer.currentindex
    // after based on some conditions, it is set to timer1 or timer2
    // timer1 : is used for setting the tab order of timer after hotspots
    // timer2 : is used for setting the tab order of timer after going from tools
    timer = {
        currentIndex: -1,
        entity: ''
    }
    timerCrossBtn = {
        currentIndex: -1,
        entity: ''
    }    
    
    // To handle tab order of tip modal of spotlight and masking button
    // same tip modal is used for both spotlight and masking button
    // so to change the tab index on runtime, we are using tipModal entity
    // tipModal1 : on enter of spotlight button
    // tipModal2 : on enter of masking button
    tipModal = {
        currentIndex: -1,
        entity: '',
        onClose: this.focusParent.bind(this)
    }

    /**
     * The constructor for the TabbingOrderService.
     * 
     * The constructor is responsible for creating a flattened version of the
     * tab order map from the hierarchical tab order map when the service is
     * instantiated.
     */
    constructor() {
        /**
         * Create a flattened version of the tab order map from the
         * hierarchical tab order map.
         * 
         * @param obj The current element of the hierarchical tab order map.
         * @param index The current tab index.
         * @param parentKey The entity name of the parent of the current element.
         * @returns The final tab index of the current element.
         */
        this.handleTabOrderOnResize();
    }

    /**
     * Handles the window resize event and updates the tab order map based on the window width.
     * 
     * @param event - The resize event object.
     * 
     * If the window width is between 
     * 991 to 1239 pixels, it updates the tab order map to tabOrderMapTablet. 
     * Till 991px , it updates the tab order map to tabOrderMapMobile.
     * Otherwise, it updates the tab order map to tabOrderMap.
     */
        public handleTabOrderOnResize() {
            let newWindow;
            if (window.innerWidth <= 991 ) {
                newWindow = 'mobile';
            }
            else if (window.innerWidth > 991 && window.innerWidth <= 1239) {
                newWindow = 'desktop'; 
            } 
            else {
                newWindow = 'largeDesktop';
            }
            if (this.currentWindow !== newWindow) {
                this.createFlatTabOrderMap(this.tabOrderMap[newWindow], 2);
                this.currentWindow = newWindow;
            }
        }

    /**
     * Sets the timer and its corresponding cross button tab index from the flattened tab order map.
     *
     * @param timer - The key for the timer in the flattened tab order map.
     */
    public setTimerMap(timer){
        let crossBtn1 = timer + 'CrossBtn';
        this.timer = this.flattenedTabOrderMap[timer];
        this.timerCrossBtn = this.flattenedTabOrderMap[crossBtn1];
    }

    /**
     * Sets the tip modals tab index from the flattened tab order map.
     *
     * @param tipModal - The key for the tipModal in the flattened tab order map.
     */
    public setTipModalMap(tipModal){
        setTimeout(() => {
            this.tipModal = this.flattenedTabOrderMap[tipModal];
        }, 0);        }
        
    /**
     * Recursively creates a flattened version of the tab order map from the
     * hierarchical tab order map.
     * 
     * @param obj The current element of the hierarchical tab order map.
     * @param index The current tab index. When this function is  called for the first time,
     * index signifies the offset value from where the tab index inside the eReader is to be started
     * @param parentKey The entity name of the parent of the current element.
     * @returns The final tab index of the current element.
     */
    private createFlatTabOrderMap(obj, index, parentKey?) { 
        // Loop through all the children of the current element
        obj.forEach((element) => {
            // Create a new object in the flattened tab order map with the
            // current index as the starting, current, and final index and
            // the parent entity name as the parent.
            this.flattenedTabOrderMap[element.entity] = {
                entity: element.entity,
                startIndex: index,
                currentIndex: index,
                finalIndex: index,
                parent: element.parent || parentKey,
                onClose: element.onClose,
                // If the current element has children, create a new array
                // with the entity names of the children.
                children: element.children ? element.children.map((element) => {
                    return element.entity;
                }) : undefined
            }
            // If the current element has children, recursively call this
            // function to create the flattened tab order map for the
            // children.
            if(element.children) {
                // Get the final tab index of the current element after
                // recursively calling this function.
                let idx:number = this.createFlatTabOrderMap(element.children, ++index, element.entity);
                // Set the final index of the current element to the final
                // index of the last child.
                this.flattenedTabOrderMap[element.entity].finalIndex = idx;
                // Set the current index to the final index of the last child
                // plus one.
                index = idx + 1;
            }else {
                // If the current element does not have children, simply
                // increment the current index.
                ++index;
            }
        })

        this.timer = this.flattenedTabOrderMap['timer1'];
        this.tipModal = this.flattenedTabOrderMap['tipModal1'];


        // Return the final tab index of the current element.
        return index;
    }

    /**
     * Recursively sets the tabindex of the given element and all its ancestors to
     * either the starting or final index of the ancestor, depending on the value
     * of the `order` parameter.
     * 
     * The purpose of this function is to ensure that when the user navigates away
     * from the element and back to it, the tabindex of the element is reset to
     * the original value. This is needed because the tabindex of an element can
     * be changed by the browser when the user navigates away from the element and
     * back to it.
     * 
     * @param element The element for which to set the tabindex.
     * @param order The order in which to set the tabindex. If 'first', the tabindex
     * is set to the starting index of the ancestor. If 'last', the tabindex is set
     * to the final index of the ancestor.
     */
    public firsElementOrLastElement(element, order) {
        // If the element is null or undefined, do nothing
        if (!element) {
            return;
        }

        // Get the current element from the map
        let currElem = this.flattenedTabOrderMap[element];

        // If the current element has a parent element in the map
        if (currElem?.parent && this.flattenedTabOrderMap[currElem.parent]) {
            // Get the parent element from the map
            let parentElem = this.flattenedTabOrderMap[currElem.parent];

            // Set the tabindex of the parent element to either the starting index
            // or final index of the parent element, depending on the value of the
            // order parameter
            parentElem.currentIndex = order === 'first' ? parentElem.startIndex : parentElem.finalIndex;

            // Recursively set the tabindex of the parent element
            this.firsElementOrLastElement(currElem.parent, order);
        }
    }


    /**
     * Resets the tabindex of the given element and all its children to the starting
     * index. This is needed when the user navigates away from the element and back
     * to it, so that the tabindex gets reset to the original value.
     * 
     * @param element The element for which to reset the tabindex.
     */
    public resetTabIndex(element) { 
        // Get the current element from the map
        let currElem = this.flattenedTabOrderMap[element];

        // If the current element has children, recursively reset their tabindexes
        if(currElem?.children) {
            // Loop through all the children of the current element
            currElem.children.forEach((elem) => {
                // If the child element has children of its own, recursively call
                // this function to reset their tabindexes
                if(this.flattenedTabOrderMap[elem].children) {
                    this.resetTabIndex(elem);
                }
            })
        }

        // Finally, reset the tabindex of the current element to its starting index
        if(currElem) {
            this.flattenedTabOrderMap[element].currentIndex = this.flattenedTabOrderMap[element].startIndex;
        }
    }

    /**
     * Resets the current index of each element in the flattenedTabOrderMap.
     * after traversing the complete page
     * @param finalIndex - If true, sets the current index to the final index of each element.
     *                     If false, sets the current index to the start index of each element.
     */
    public resetMap(finalIndex = false){
        for (const key in this.flattenedTabOrderMap) {
            if (Object.prototype.hasOwnProperty.call(this.flattenedTabOrderMap, key)) {
                const element = this.flattenedTabOrderMap[key];
                if(finalIndex){
                    element.currentIndex = element.finalIndex;
                }else{
                    element.currentIndex = element.startIndex;
                }
            }
        }
    }

    public focusParent(entity, options?) {
        // Get the parent element from the map
        let parentElem = document.getElementById(entity.parent);
        if (options?.firstVisibleParent) {
            if (!parentElem)
                this.focusParent(this.flattenedTabOrderMap[entity.parent], options);
            else
                setTimeout(() => {
                    parentElem.focus();
                },);
        }
        else {
            setTimeout(() => {
                parentElem && parentElem.focus();
            },);
        }
    }
}
